import { mentorPerformanceApis } from '@shared/apis';
import { genericQueryWithParams } from './generics';

export const useGetMentorPerformance =
  genericQueryWithParams<mentorPerformanceApis.GetMentorPerformance>(
    mentorPerformanceApis.getMentorPerformance
  );
